module.exports = __webpack_public_path__ + "img/product_4.0e8d8f3.webp";